import { SortingState } from "@tanstack/react-table";

interface ITableFigure {
    id: string;
    orderDescending: boolean | null;
}

export const getFirstSortableFigureSortingState = (figures: ITableFigure[], defaultSortingFigureId: string): SortingState => {
    const foundFigure = figures.find(fig => fig.orderDescending || fig.orderDescending === false);

    return foundFigure
        ? [
              {
                  id: foundFigure.id,
                  desc: Boolean(foundFigure.orderDescending),
              },
          ]
        : [
              {
                  id: defaultSortingFigureId,
                  desc: false,
              },
          ];
};
